/**
 * Custom ElasticPress Autosuggest.
 *
 * This file is largely based on `autosuggest.js` shipped with ElasticPress 2.8.1
 * with modifications added as needed.
 *
 * @package Microsoft Research
 */

/* eslint-disable */
(function ($) {
	"use strict";

	// No host/index set
	if (
		!window.epAutosuggest ||
		!window.epAutosuggest.endpoint ||
		"" === window.epAutosuggest.endpoint
	) {
		return;
	}

	let currentRequest = null;
	let $noResultsEl = null;
	let $noResultsMessageEl = null;
	let $uhfSearchInput = null;

	/**
	 * UHF is picky about selectors. Here we hack it to re-target the
	 * 'aria-controls' to our custom autosuggest dropdown.
	 *
	 * @param {jQuery} $epContainer Created in JS node for our EP container.
	 */
	function modifyUHFTargets($epContainer) {
		const oldAutoSuggest = $(
			"#universal-header-search-auto-suggest-transparent",
		);
		const newAutoSuggest = $epContainer.find(".ep-autosuggest");
		const newCMenu = newAutoSuggest.find(".autosuggest-list");

		if (!oldAutoSuggest || !newAutoSuggest || !newCMenu) {
			return;
		}

		oldAutoSuggest.removeAttr("id");
		newAutoSuggest.attr(
			"id",
			"universal-header-search-auto-suggest-transparent",
		);

		// Part of the UHF selectors, without it we get an error.
		newCMenu.addClass("c-menu");
	}

	/**
	 * Submit the search form
	 * @param object $localInput
	 */
	function submitSearchForm($localInput) {
		$localInput.closest("form").submit();
	}

	/**
	 * Take selected item and fill the search input
	 * @param event
	 */
	function selectAutosuggestItem($localInput, text) {
		$localInput.val(text);
	}

	/**
	 * Update the window location
	 * @param {string} url - qualified url
	 */
	function goToAutosuggestItem(url) {
		return (window.location.href = url);
	}

	/**
	 * Respond to an item selection based on the predefined behavior.
	 * If epAutosuggest.action is set to "navigate" (the default), redirects the browser to the URL of the selected item
	 * If epAutosuggest.action is set to any other value (such as "search"), fill in the value and perform the search
	 *
	 * @param $localInput
	 * @param element
	 */
	function selectItem($localInput, element) {
		if ("navigate" === window.epAutosuggest.action) {
			return goToAutosuggestItem(element.dataset.url);
		}

		selectAutosuggestItem($localInput, element.innerText);
		submitSearchForm($localInput);
	}

	/**
	 * Simple throttling function for waiting a set amount of time after the last keypress
	 * So we don't overload the server with too many requests at once
	 *
	 * @param fn
	 * @param delay
	 * @returns {Function}
	 */
	function debounce(fn, delay) {
		let timer = null;

		return function () {
			const context = this,
				args = arguments;

			window.clearTimeout(timer);

			timer = window.setTimeout(function () {
				fn.apply(context, args);
			}, delay);
		};
	}

	/**
	 * Build the ajax request
	 *
	 * @param query
	 * @returns AJAX object request
	 */
	function esSearch(query) {
		// Fixes <=IE9 jQuery AJAX bug that prevents ajax request from firing
		jQuery.support.cors = true;

		hideNoResultsMessage();

		const {
			epAutosuggest: { endpoint, locale },
		} = window;

		query = {
			...query,
			locale,
		};

		return $.ajax({
			url: endpoint,
			type: "get",
			dataType: "json",
			contentType: "application/json; charset=utf-8",
			crossDomain: true,
			data: query,
		});
	}

	/**
	 * Update the auto suggest box with new options or hide if none
	 *
	 * @param options
	 * @return void
	 */
	function updateAutosuggestBox(options, $localInput) {
		const optionsLength = options.length;
		const $localContainer = $localInput.closest(
			".ep-autosuggest-container",
		);
		const $localAutosuggest = $localContainer.find(".ep-autosuggest");
		const $localAutosuggestList = $localContainer.find(".autosuggest-list");
		const $localStatus = $localContainer.find(".ep-autosuggest-status");

		$localStatus.empty();
		$localAutosuggestList.empty();
		$localAutosuggestList.attr({
			"aria-expanded": "true",
		});

		$localInput.attr({
			"aria-expanded": "true",
		});

		const status =
			options.length === 1 ? "1 result" : `${options.length} results`;

		if (0 < options.length) {
			$localStatus.text(status);
			$localAutosuggest.show();
			hideNoResultsMessage();
		} else {
			$localAutosuggest.hide();
			showNoResultsMessage();
		}

		/**
		 * MSR - updated section
		 *
		 * The original itemString brings only the text and url. We're enhancing it with a type
		 * value that's derived from the content type retrieved.
		 *
		 * @since 0.1.0
		 */
		for (let i = 0; i < optionsLength; ++i) {
			const { text, url, type } = options[i];
			const itemString =
				`<li tabindex="0" role="option"><span class="autosuggest-item" data-search="${text}" title="${url}" data-url="${url}">` +
				`<span class="type">${type}&nbsp;</span>${text}</span></li>`;
			$(itemString).appendTo($localAutosuggestList);
		}
	}

	/**
	 * Hide the auto suggest box
	 *
	 * @return void
	 */
	function hideAutosuggestBox() {
		$(".autosuggest-list").empty().attr({
			"aria-expanded": "false",
		});

		$("#search-query").attr({
			"aria-expanded": "false",
		});

		$(".ep-autosuggest").hide();
	}

	/**
	 * Hide the "no results" message.
	 *
	 * @return void
	 */
	function hideNoResultsMessage() {
		if (!$noResultsEl) {
			$noResultsEl = $(".f-auto-suggest-no-results");
		}

		$noResultsEl
			.attr({
				"aria-hidden": "true",
			})
			.hide();
	}

	/**
	 * Show the "no results" message.
	 *
	 * @return void
	 */
	function showNoResultsMessage() {
		// The "no results" message element is included with UHF, so we need some additional logic to make the message will work seamlessly with autosuggest results we get from Elasticsearch.
		if (!$uhfSearchInput) {
			$uhfSearchInput = $("#cli_shellHeaderSearchInput");
		}

		// Since the "no results" message element is only available for the search field in UHF, only show it if that search filed is visible. Otherwise, the message will be shown floating in the UHF header when using the search field above results on the search results page. In the future, we should add our own "no results" element that will work for any search field that displays suggestions results.
		if (!$uhfSearchInput || !$uhfSearchInput.is(":visible")) {
			return;
		}

		if (!$noResultsEl) {
			$noResultsEl = $(".f-auto-suggest-no-results");
		}

		if ($noResultsEl && !$noResultsMessageEl) {
			$noResultsMessageEl = $noResultsEl.find(".c-menu-item span");
		}

		// In some cases the "no results" message element included with UHF is not populated when we get results back from Elasticsearch. This code ensures there is always a message before showing it.
		if ($noResultsMessageEl) {
			$noResultsMessageEl.attr({ "aria-label": "No results" });
			$noResultsMessageEl.text("No results");
		}

		// Show the message.
		$noResultsEl
			.attr({
				"aria-hidden": "false",
			})
			.show();

		const status = $noResultsEl.text();

		$(".ep-autosuggest-status").text(status);
	}

	/**
	 * MSR - updated section
	 *
	 * This function does not exist in the original file. It was added as a helper
	 * to identify the post type and return the correct labels to use.
	 *
	 * @since 0.1.0
	 */
	function getType(element) {
		let type = "";

		if ("roles" in element) {
			type = "Researcher";
		} else if (
			"undefined" !== typeof element.terms &&
			"undefined" !== typeof element.terms["msr-content-type"] &&
			0 < element.terms["msr-content-type"].length
		) {
			type = element.terms["msr-content-type"][0].name;
		} else {
			type = element.post_type;

			switch (type) {
				case "msr-section-front":
					type = "Research Area";
					break;
				case "msr-research-lab":
					type = "Lab";
					break;
				case "msr-blog-post":
					type = "Article";
					break;
				case "msr-job-opportunity":
					type = "Career Opportunity";
					break;
				case "post":
					type = "Microsoft Research Blog";
					break;
				case "msr-new-item":
					type = "News item";
					break;
				default:
					type = type.replace("msr-", "").replace("-", " ");
					break;
			}
		}

		return type;
	}

	const $epInput = $(
		'.ep-autosuggest, input[type="search"], .search-field, #cli_shellHeaderSearchInput',
	);
	const $epAutosuggest = $(
		'<div class="ep-autosuggest"><ul class="autosuggest-list"></ul></div>',
	);
	const $epStatus = $(
		'<div class="ep-autosuggest-status sr-only" role="status"></div>',
	);

	/**
	 * Event handler, force focus on first item in results list
	 * @param {Object} event
	 */
	function maybeDoFirstItemFocus(event) {
		if (event.key === "ArrowDown") {
			event.preventDefault();

			$(this)
				.closest(".ep-autosuggest-container")
				.find(".autosuggest-list li")
				.eq(0)
				.focus();
		}

		if (event.key === "ArrowUp") {
			event.preventDefault();

			$(this)
				.closest(".ep-autosuggest-container")
				.find(".autosuggest-list li")
				.last()
				.focus();
		}
	}

	$epInput.each(function (key, input) {
		const $epContainer = $('<div class="ep-autosuggest-container"></div>');
		const $input = $(input);
		const customControlID = `autosuggest-list-${key}`;

		// Pass attrs to input
		$input.attr({
			autocomplete: "off",
			role: "combobox",
			"aria-expanded": false,
		});

		$epContainer.insertAfter($input);
		const $epLabel = $input.siblings("label");
		$input
			.closest("form")
			.find(".ep-autosuggest-container")
			.append($epLabel)
			.append($input);

		$epStatus.clone().insertAfter($input);
		$epAutosuggest.clone().insertAfter($input);

		// Set the input/results relationship via ID
		$epContainer.find(".autosuggest-list").attr({
			id: customControlID,
			role: "listbox",
		});

		$input.trigger("elasticpress.input.moved");

		// Prevent closing on click
		$epContainer.on("click", function (event) {
			event.stopPropagation();
		});

		// Call before we run the selectors below.
		modifyUHFTargets($epContainer);
	});

	$epAutosuggest.css({
		top: $epInput.outerHeight() - 1,
		"background-color": $epInput.css("background-color"),
	});

	/**
	 * Typeahead listener:
	 * Listen for any keyup events, throttle them to a min threshold of time
	 * and then send them for a query to the Elasticsearch server
	 *
	 */
	$epInput.each(function (key, localInput) {
		const $localInput = $(localInput);

		// Immediately listen for
		$localInput.on("keydown", maybeDoFirstItemFocus);

		// Monitor keystrokes
		$localInput.on(
			"keydown",
			debounce(function (event) {
				if (
					[
						"ArrowDown",
						"ArrowLeft",
						"ArrowRight",
						"ArrowUp",
						"Enter",
						"Escape",
					].includes(event.key)
				) {
					return;
				}

				const val = $localInput.val();
				let query;

				if (2 <= val.length) {
					query = { search: val };

					// Abort the previous request if it's pending so we don't have to wait for it to complete first.
					if (
						currentRequest &&
						currentRequest.readyState &&
						currentRequest.readyState !== 4
					) {
						currentRequest.abort();
					}

					currentRequest = esSearch(query);

					if (currentRequest) {
						currentRequest.done(function (response) {
							if (0 !== response.length) {
								const usedPosts = {};
								const filteredObjects = [];

								/**
								 * MSR - updated section
								 *
								 * This section was updated to allow retrieving values from different content types
								 * (posts,users) as well as passing the type information to the filteredObjects array.
								 *
								 * @since 0.1.0
								 */
								$.each(response, function (index, element) {
									const type = getType(element);
									const urlbase = `https://${window.location.hostname}/en-us/research`;
									const text =
										element.post_title ||
										element.data.display_name;
									const url =
										element.permalink ||
										element.guid ||
										`${urlbase}/people/${element.data.user_login}`;
									const postId = element.ID;

									if (!usedPosts[postId]) {
										usedPosts[postId] = true;

										filteredObjects.push({
											text: text,
											url: url,
											type: type,
										});
									}
								});

								if (0 === filteredObjects.length) {
									hideAutosuggestBox();
									showNoResultsMessage();
								} else {
									updateAutosuggestBox(
										filteredObjects,
										$localInput,
									);
								}
							} else {
								hideAutosuggestBox();
								showNoResultsMessage();
							}
						});
					}
				} else if (0 === val.length) {
					hideAutosuggestBox();
					hideNoResultsMessage();
				}
			}, 200),
		);
	});

	// Close results list on document escape key
	$(document).on("keydown", function (event) {
		if (event.key === "Escape") {
			hideAutosuggestBox();
			hideNoResultsMessage();
		}
	});

	// Close results list when clicking away from the suggestions
	$(document).on("click", function (event) {
		hideAutosuggestBox();
	});

	// Listen to keyup event on List of results
	// Useful for arrow controls through the list of results
	$(".autosuggest-list").on("keydown", function (event) {
		const { key } = event;
		const { activeElement } = document;

		const container = event.currentTarget.closest(
			".ep-autosuggest-container",
		);
		const input = container.querySelector('input[type="search"]');

		if (key.length === 1 && key.match(/\S| /)) {
			input.focus();
		}

		if (["ArrowLeft", "ArrowRight"].includes(key)) {
			input.focus();
		}

		if ("ArrowDown" === key) {
			event.preventDefault();

			const nextSibling = activeElement && activeElement.nextSibling;

			if (nextSibling) {
				activeElement.nextSibling.focus();
			} else {
				input.focus();
			}
		}

		if ("ArrowUp" === key) {
			event.preventDefault();

			const previousSibling =
				activeElement && activeElement.previousSibling;

			if (previousSibling) {
				activeElement.previousSibling.focus();
			} else {
				input.focus();
			}
		}

		if (key === "Enter") {
			event.preventDefault();

			const $currentFocus = $(activeElement);
			const $container = $currentFocus.closest(
				".ep-autosuggest-container",
			);
			const $input = $container.find('input[type="search"]');

			selectItem($input, $currentFocus.children("span").get(0));
		}

		if (key === "Escape") {
			event.stopPropagation();

			input.focus();
			hideAutosuggestBox();
		}
	});

	// Listen to items to auto-fill search box and submit form
	$(".autosuggest-list").on("click", ".autosuggest-item", function (event) {
		event.stopPropagation();
		let element = event.target;

		// If you click on a label it won't have the data parameters so
		// find the parent and use it
		if (!event.target.dataset.url) {
			element = event.target.parentElement;
		}

		const $currentFocus = $(element);
		const $container = $currentFocus.closest(".ep-autosuggest-container");
		const $input = $container.find('input[type="search"]');

		selectItem($input, element);
	});

	/**
	 * Shift + Tab from the main search input doesn't collapse
	 * the search results. Because this action moves focus to the
	 * main Search Button (maginfying glass), we can lean on this
	 * event to assure that the search results close properly.
	 */
	$("button#search").on("focus", () => {
		if (!$("#cli_shellHeaderSearchInput:visible").length) {
			hideAutosuggestBox();
			hideNoResultsMessage();
		}
	});
})(jQuery);
